module.exports = __webpack_public_path__ + "static/media/hinted-MaisonNeue-BoldItalic.7954afdf.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/maison/hinted-MaisonNeue-BoldItalic.eot
// module id = 100
// module chunks = 0